<template>
  <a-layout style="min-height: 100vh">

    <a-layout-header class="top" style="background: #fff; padding: 0" >
      <common-home-header/>
    </a-layout-header>
    <a-layout>
      <a-layout-sider  theme="light" >
        <PlatformMenu />
      </a-layout-sider>
      <a-layout-content style="margin: 0 16px">

        <div :style="{ padding: '24px 0px' }">
          <router-view/>
        </div>

        <a-layout-footer>
          <PlatformFooter></PlatformFooter>
        </a-layout-footer>
      </a-layout-content>

    </a-layout>
  </a-layout>
</template>

<script setup>
import PlatformFooter from "@/components/components_platform/PlatformFooter.vue";
import CommonHomeHeader from "@/components/components_business/header/CommonHomeHeader.vue";
import PlatformMenu from "@/components/components_business/menu/PlatformMenu.vue";
</script>

<style scoped>
.top{
  margin: 0;
  padding: 0 20px;
  border-bottom: #efefef 1px solid;
}
.logo{
  height: 45px;
  line-height: 45px;
  margin: 10px;
  background: rgba(255, 255, 255, 0.3);
}
.logo-title{
  text-align: center;
  color: #ffffff;
  font-size: 15px;
}
.site-layout .site-layout-background {
  background: #fff;
}
</style>